import { ViewController } from 'foundations-components/transitional/components/ViewController';
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiButtonToggle = ({
  onChangeHandler,
  buttonOptions,
  value
}) => {
  return /*#__PURE__*/_jsx(ViewController, {
    onChange: onChangeHandler,
    options: buttonOptions,
    value: value
  });
};
MultiButtonToggle.displayName = 'MultiButtonToggle';